import React from "react";

const HalfRadialChart = () => {
	return (
		<div>
			<div className="overflow-hidden">
				<div className="multi-graph margin">
					<div
						className="graph"
						data-name="jQuery"
						style={{ "--percentage": "100", "--fill": "#17BEE2" }}
					></div>
					<div
						className="graph"
						data-name="jQuery"
						style={{ "--percentage": "96", "--fill": "#5D35FF" }}
					></div>
					<div
						className="graph"
						data-name="jQuery"
						style={{ "--percentage": "92", "--fill": "#FF3559" }}
					></div>
					<div
						className="graph"
						data-name="React"
						style={{ "--percentage": "88", "--fill": "#FFAA35" }}
					></div>
					<div
						className="graph"
						data-name="Angular"
						style={{ "--percentage": "80", "--fill": "#2263C5" }}
					></div>
					<div
						className="graph"
						data-name="jQuery"
						style={{ "--percentage": "50", "--fill": "#22C55C" }}
					></div>
					<div className="dognut-inner-content">
						<h5>609.8K</h5>
						<span>Supply</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HalfRadialChart;
